import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searcher'
})
export class SearcherPipe implements PipeTransform {

  transform(data: any[], text: string, field: string): any[] {

    if (text === undefined || text.length === 0 || text.length < 3) {
      return data;
    };

    return data.filter(any => {
      return any[field].toLocaleLowerCase().includes(text.toLocaleLowerCase());
    });
  }

}
